import React from "react";
import { Container } from "react-bootstrap";
import Loader from "react-loader";
import Error from "../pages/Error";

export function withData(WrappedComponent: any, title: string, selectData: any): any 
{
    interface WithDataState
    {
        data: any;
    }

    return class WithData extends React.Component<any, WithDataState>
    {
        constructor(props: any) 
        {
            super(props);
        }

        async componentDidMount(): Promise<void> 
        {
            const data = await selectData(this.props);
            this.setState({ data: data });
        }

        render(): React.ReactNode 
        {
            return this.state
                ?
                this.state.data == null ? <Error name={title} /> : <WrappedComponent data={this.state.data} {...this.props} />
                :
                <Container style={{ height: "100px", padding: "50px" }}>
                    <Loader className={"spinner"} position={"relative"} scale={0.5} radius={15} corners={1} color={"#000"} opacity={0.25} rotate={0} direction={1} speed={1} trail={60} />
                </Container>;
        }
    };
}